// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Scenario/Scenario.css */

.scenario {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 50px);
    overflow-y: auto;
    position: relative;
  }

  .lanes-container {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    min-height: 300px;
    padding: 10px;
  }
  
  .scenario svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }`, "",{"version":3,"sources":["webpack://./src/components/Scenario/Scenario.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;EACb","sourcesContent":["/* src/components/Scenario/Scenario.css */\n\n.scenario {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 50px);\n    overflow-y: auto;\n    position: relative;\n  }\n\n  .lanes-container {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    min-height: 300px;\n    padding: 10px;\n  }\n  \n  .scenario svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
